import React, { useState, useRef, useEffect } from 'react';
import { useTheme, themes } from '../context/ThemeContext';
import './ThemeSelector.css';

function ThemeSelector() {
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentTheme = themes[theme];

  const getThemeIcon = (themeId) => {
    switch (themeId) {
      case 'minimal':
        return (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          </svg>
        );
      case 'elegant':
        return (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          </svg>
        );
      case 'dark':
        return (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7c0-.62-.08-1.21-.23-1.78-.45.57-1.13.94-1.9.94-1.37 0-2.48-1.11-2.48-2.48 0-.77.37-1.45.94-1.9C10.21 1.08 9.62 1 9 1H8z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          </svg>
        );
      case 'organic':
        return (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 2C5 2 3 5 3 8c0 3 2 6 5 6s5-3 5-6c0-3-2-6-5-6z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
            <path d="M8 2c0 2-1 4-1 6s1 4 1 6" stroke="currentColor" strokeWidth="1"/>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="theme-selector" ref={dropdownRef}>
      <button
        className="theme-selector-trigger"
        onClick={() => setIsOpen(!isOpen)}
        title="Changer le theme"
      >
        {getThemeIcon(theme)}
        <span className="theme-selector-label">{currentTheme.name}</span>
        <svg className={`theme-selector-chevron ${isOpen ? 'open' : ''}`} width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {isOpen && (
        <div className="theme-selector-dropdown">
          <div className="theme-selector-header">Choisir un theme</div>
          {Object.values(themes).map((t) => (
            <button
              key={t.id}
              className={`theme-selector-option ${theme === t.id ? 'active' : ''}`}
              onClick={() => {
                setTheme(t.id);
                setIsOpen(false);
              }}
            >
              <span className="theme-option-icon">{getThemeIcon(t.id)}</span>
              <div className="theme-option-content">
                <span className="theme-option-name">{t.name}</span>
                <span className="theme-option-description">{t.description}</span>
              </div>
              {theme === t.id && (
                <svg className="theme-option-check" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ThemeSelector;
